// DEPENDENCIES
import _ from "lodash";

// COMPONENTS
import { SubFormDefinition } from "../../../../../../../../utils/forms/components/FormSet";

// STORE
import { SelectedGroupsByProgressive } from "../../../../../../models/SelectedGroupsByProgressive";
import {
    GROUP_TYPE,
    TerminalGroupConfiguration,
    GameGroupConfiguration
} from "../../../../../../reducers/editingConfiguration.reducer";

// UTILS
import groupListOfType from "../../../../../Utils/full-group-list";
import getSelectableCoins from "../../../../../Utils/GetSelectableCoins/get-selectable-coins";
import { parseAvailableGroups } from "../../../../../Utils/parse-available-groups";
import buildFormGridFields from "../../../../../../../../utils/forms/builders/build-form-grid-fields";
import buildSchemaCompliantDefinition from "../../../../../../../../utils/forms/builders/build-schema-compliant-definition";

// CONTANTS AND DEFAULTS
import * as CONFIG_CONSTANTS from "../ProgressivesConfigurationSection.constants";

/* Load Constants */
import {
    checkRenderForProvider,
    checkDefaultForType,
    getNewGeneratedId,
    uuidv4
} from "../../../../../../../../utils/utils";

export const proportionalSubforms = props =>
    _.memoize(
        ({
            terminalGroups,
            gameGroups,
            selectedTerminalGroups,
            selectedGameGroups,
            schema,
            selectedGroupType,
            progressivesConfig
        }): SubFormDefinition[] => {
            const coins = getSelectableCoins(props);

            return [
                _createProportionalSubform(
                    schema,
                    terminalGroups,
                    gameGroups,
                    selectedTerminalGroups,
                    selectedGameGroups,
                    selectedGroupType,
                    progressivesConfig,
                    coins
                )
            ];
        }
    );

function _createProportionalSubform(
    schema: any,
    terminalGroups: TerminalGroupConfiguration[],
    gameGroups: GameGroupConfiguration[],
    selectedTerminalGroups: SelectedGroupsByProgressive,
    selectedGameGroups: SelectedGroupsByProgressive,
    selectedGroupType: GROUP_TYPE,
    progressivesConfig,
    coins
): SubFormDefinition {
        const tempProgressiveSchema = schema.definitions.$proportional_jackpot;

    const requiredGroupFields =
        selectedGroupType == null
            ? "groups_placeholder"
            : selectedGroupType == GROUP_TYPE.GAME
            ? "game_groups"
            : "terminal_groups";

    let progressiveSchema = {
        ...tempProgressiveSchema,
        required: [...tempProgressiveSchema.required, requiredGroupFields]
    };

    progressiveSchema.properties["id"]["unique"] = progressivesConfig.filter(progressive => progressive.type === "proportional").map(progressive => progressive.id);

    if (selectedGroupType == null) {
        progressiveSchema.properties = {
            ...progressiveSchema.properties,
            [requiredGroupFields]: { type: "string" }
        };
    }

    const fullGroupList = groupListOfType(
        selectedGroupType,
        terminalGroups,
        gameGroups
    );

    const selectedGroupList = parseAvailableGroups(
        terminalGroups,
        selectedTerminalGroups,
        gameGroups,
        selectedGameGroups,
        "proportional",
        selectedGroupType
    );

    const exclusiveFields = Object.keys(progressiveSchema.properties).filter(
        property => {
            return (
                progressiveSchema.properties[property].hasOwnProperty(
                    "exclusive"
                ) && progressiveSchema.properties[property].exclusive == true
            );
        }
    );

    const groupTypeFormDefinition = CONFIG_CONSTANTS.progressiveFormDefinition(
        selectedGroupType,
        coins,
        fullGroupList,
        selectedGroupList,
        [],
        undefined,
        {
            max_bet: "Max. Proportional Bet",
            max_bet_placeholder: "Insert Max. Proportional Bet"
        },
        exclusiveFields,
        undefined,
        'proportional'
    );

    const formDefinition = buildSchemaCompliantDefinition(
        progressiveSchema,
        groupTypeFormDefinition,
        [
            CONFIG_CONSTANTS.SCHEMA_NAMES.ID,
            CONFIG_CONSTANTS.SCHEMA_NAMES.COIN,
            CONFIG_CONSTANTS.SCHEMA_NAMES.GLOBAL_JACKPOT_SOUND,
            CONFIG_CONSTANTS.SCHEMA_NAMES.GROUPS
        ]
    );

    return {
        formType: "proportional",
        addLabel: "",
        emptyValue: defaultsProportional({
            schema: schema,
            progressivesConfig: progressivesConfig
        }),
        fields: buildFormGridFields(progressiveSchema, formDefinition, schema)
    };
}

const defaultsProportional = _.memoize(({ schema, progressivesConfig }) => {
    let defaults = {};
    defaults["terminal_groups"] = [];
    defaults["id"] = getNewGeneratedId("Proportional", progressivesConfig);
    defaults["uuid"] = uuidv4();

    Object.keys(schema.definitions.$proportional_jackpot.properties).map(
        item => {
            if (item !== "id" && item !== "uuid") {
                defaults[item] =
                    checkRenderForProvider(
                        item,
                        schema.definitions.$proportional_jackpot.properties
                    ) &&
                    schema.definitions.$proportional_jackpot.properties[item]
                        ? (schema.definitions.$proportional_jackpot.properties[
                              item
                          ].convert
                              ? schema.definitions.$proportional_jackpot
                                    .properties[item].default / 100
                              : schema.definitions.$proportional_jackpot
                                    .properties[item].default) ||
                          checkDefaultForType(
                              schema.definitions.$proportional_jackpot
                                  .properties[item].type
                          )
                        : null;
            }
        }
    );

    defaults["type"] = "proportional";

    return defaults;
});
